import React from 'react'
import styles from './styles'

import { withStyles } from '@material-ui/core/styles'
import { Typography, Box, Divider, Card } from '@material-ui/core'
import Lottie from 'react-lottie'

import { track } from '@amplitude/analytics-browser'
import aiReadyLottie from 'src/lotties/ai-course-ready-lottie.json'
import animationDataMobile2 from 'src/lotties/mcg-v4-mobile-desktop.json'
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos'
import { CoreButton } from 'src/components/core'
import { useHistory, useLocation } from 'react-router-dom'
import { useCoursePreviewUrl } from 'src/hooks/useCoursePreviewUrl'

const AiCourseReady = props => {
  const { courseData, classes } = props
  const previewUrl = useCoursePreviewUrl(courseData)
  const history = useHistory()
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const collectionId = searchParams.get('collectionId')

  const aiReadyLottieOptions = {
    loop: true,
    autoplay: true,
    animationData: aiReadyLottie,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  }

  const mobileLottieOptions = {
    loop: true,
    autoplay: true,
    animationData: animationDataMobile2,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  }
  const handleRedirect = () => {
    if (
      collectionId !== 'undefined' &&
      collectionId !== 'null' &&
      collectionId !== null &&
      collectionId !== undefined &&
      collectionId !== ''
    ) {
      history.push(`/collection/${collectionId}/mini-courses`)
    } else {
      history.push(`/courses`)
    }
    track('ai_course_created_edited', {
      from: 'stepper',
      courseId: courseData.id,
    })
  }
  return (
    <>
      <div
        className={classes.nonMobileViewForFinishScreen}
        style={{ textAlign: 'center' }}
      >
        <Typography variant="h4">
          Your engaging course is ready!
        </Typography>
        <Typography className={classes.gatewayTooltipStyle}>
          You can enrich it with questions, images, videos, revisions,
          customized endings, etc., to make <br /> the content uniquely yours.
        </Typography>

        <CoreButton
          onClick={() => {
            handleRedirect()
          }}
          variant="contained"
        >
          Edit Course
        </CoreButton>
        <div
          onClick={() => {
            handleRedirect()
          }}
        >
          <Lottie options={aiReadyLottieOptions} />
        </div>
      </div>

      <div className={classes.mobileViewForFinishScreen}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '24px',
          }}
        >
          <Typography fontSize={24} fontWeight={600} textAlign={'center'}>
            Hi {window.CONSTANTS.NAME} 👋
          </Typography>
          <Typography fontSize={16} fontWeight={400} textAlign={'center'}>
            Creating, editing and managing courses are optimized for
            desktop browsers. Please visit your account{' '}
            <span
              style={{
                color: '#015FFB',
              }}
            >
              on desktop
            </span>{' '}
            for the full capability.
          </Typography>
          <Lottie options={mobileLottieOptions} width={300} height={182} />
          <div
            style={{
              borderRadius: '16px',
              padding: '20px',
              gap: '24px',
              backgroundColor: '#FFFFFF',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow:
                '0 0 2px 0 rgba(145, 158, 171, 0.12), 0 12px 24px -4px rgba(145, 158, 171, 0.12);',
            }}
          >
            <Typography
              fontSize={18}
              fontWeight={500}
              textAlign={'center'}
              color={'#015FFB'}
            >
              View your course
            </Typography>

            <Typography fontSize={16} fontWeight={400} textAlign={'center'}>
              Editing is available on desktop, but you can preview your course
              here.
            </Typography>
            <CoreButton
              variant="contained"
              size="large"
              href={previewUrl}
              target="_blank"
            >
              Preview Course
            </CoreButton>
          </div>
        </div>
      </div>
    </>
  )
}

export default withStyles(styles)(AiCourseReady)
